<template>
  <div class="avatar-detail-tags">
    <div class="avatar-detail-tags__name">{{ tag.tag_name }}{{ colon }}</div>
    <div class="avatar-detail-tags__list">
      <div
        class="avatar-detail-tags__tag"
        :class="{ 'cursor-default': !child.tag_id }"
        @click="onClick(child)"
        v-for="child in tag.children?.slice(0, 2)"
        :key="child.tag_name"
      >
        {{ child.tag_name }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { Character } from '~/api/interface/character';
import { PageKey } from '~/constants/page';
import type { DetailTag } from './detail-description/interface';

interface TagProps {
  tag: DetailTag;
  character?: Character | null;
}

const props = defineProps<TagProps>();

const resourceLocation = injectResourceLocation();

const colon = computed(() => (isChinese() ? '：' : ':'));

function onClick(childTag: DetailTag) {
  if (childTag.tag_id) {
    navigateTo({
      name: PageKey.CHARACTER,
      query: {
        tag_ids: `${props.tag.tag_id}.${childTag.tag_id}`,
      },
    });
  }

  trackEvent(TRACK_EVENT.CLICK_CHARACTER_TAG, {
    id: props.character?.id,
    name: props.character?.name,
    look_name: props.character?.look_name,
    tag_id: childTag.tag_id,
    tag_name: childTag.tag_name,
    source: resourceLocation?.source,
    tags: props.character?.tags,
  });
}
</script>
<style lang="scss" scoped>
.avatar-detail-tags {
  display: inline-flex;
  align-items: flex-start;
}
.avatar-detail-tags__name {
  color: var(--x-text-7);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  line-height: 30px;
}
.avatar-detail-tags__list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-left: 4px;
}
.avatar-detail-tags__tag {
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 16px;
  background: var(--x-purple-1);
  color: var(--x-purple-6);
  line-height: var(--x-text-16-line-height);

  cursor: pointer;

  &:hover {
    background-color: var(--x-purple-2);
    color: var(--x-purple-7);
  }

  // & + & {
  //   margin-left: 8px;
  // }

  @media (max-width: 680px) {
    pointer-events: none;
  }
}
</style>
